module.exports = "/static/assets/2c89c3945bfcd3516eb719dd9901e3b3.png";